import React from "react";
import { Link } from "react-router";
import { useTrialBanner } from "../../context/TrialBannerContext";
import { PATH } from "../../Constants/paths";
import { isSubscriptionCancelScheduled } from "../../utils/billingSubscription";
import "../../Css/Billing/TrialBanner.css";

export const TrialBanner: React.FC = () => {
  const {
    isTrialing,
    isCollapsed,
    status,
    actionLoading,
    feedbackMessage,
    daysLabel,
    collapse,
    skipTrial,
    cancelTrial,
    keepTrial,
  } = useTrialBanner();

  if (!isTrialing || isCollapsed || !status) {
    return null;
  }

  const cancelScheduled = isSubscriptionCancelScheduled(status);

  const limits = status.trial_limits;

  return (
    <section className="trialBanner" aria-label="Free trial status">
      <div className="trialBanner_inner">
        <div className="trialBanner_main">
          <div className="trialBanner_iconWrap" aria-hidden>
            <i className="fa-solid fa-sparkles" />
          </div>

          <div className="trialBanner_copy">
            <div className="trialBanner_titleRow">
              <p className="trialBanner_title">Free trial</p>
              <span className="trialBanner_badge">{daysLabel}</span>
            </div>
            <p className="trialBanner_subtitle">
              Limited to {limits.max_accounts} accounts, {limits.max_industries} industries, and{" "}
              {limits.max_users} users until you end the trial or it expires.
            </p>
            {feedbackMessage ? (
              <p className="trialBanner_feedback" role="status">
                {feedbackMessage}
              </p>
            ) : null}
          </div>
        </div>

        <div className="trialBanner_actions">
          <Link to={`${PATH.SETTINGS}#settings-billing`} className="trialBanner_link">
            Billing settings
          </Link>
          <button
            type="button"
            className="trialBanner_btn trialBanner_btn--primary"
            disabled={actionLoading}
            onClick={skipTrial}
          >
            End trial &amp; unlock plan
          </button>
          <button
            type="button"
            className="trialBanner_btn trialBanner_btn--ghost"
            disabled={actionLoading}
            onClick={cancelScheduled ? keepTrial : cancelTrial}
          >
            {cancelScheduled ? "Keep trial" : "Cancel trial"}
          </button>
          <button
            type="button"
            className="trialBanner_collapseBtn"
            onClick={collapse}
            aria-label="Minimize trial banner"
            title="Minimize to header"
          >
            <i className="fa-solid fa-chevron-up" aria-hidden />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TrialBanner;
